


















































































































































import Vue from 'vue'
import { IChronologyReply } from '@/types/data-objects/item-histories'
import ColorAssistant from '@/helpers/color-assistant'

export default Vue.extend({
  name: 'ChronologyReply',

  props: {
    replyInfo: {
      type: Object as () => IChronologyReply,
      required: true,
    },
    isReplyFromOutsideUser: {
      type: Boolean,
      default: false,
    },
    rolledOverReply: {
      type: Boolean,
      default: false,
    },
    // Function used when submit edited reply
    submitHandler: {
      type: Function,
      required: true,
      default: (): any => {},
    },
  },

  data() {
    return {
      ColorAssistant,
      isEditing: false,
      isSubmitting: false,
      showMoreOptions: false,
      editedIncomingReply: '',
    }
  },

  computed: {
    avatarSize(): number {
      if (this.$screen.isDesktop(this.$mq)) {
        return 40
      }
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return 24
      }
    },
    hasStylizedHtmlLink(): boolean {
      return (
        this.replyInfo.stylizedHtmlVersionLink !== null &&
        this.replyInfo.stylizedHtmlVersionLink.trim() !== ''
      )
    },
    hasAttachments(): boolean {
      return this.replyInfo.attachments.length > 0
    },
    hasCCs(): boolean {
      return this.replyInfo.ccs !== null && this.replyInfo.ccs.length > 0
    },
    hasBounceInfo(): boolean {
      return this.replyInfo.bounceInfo !== null
    },
    hasOtherInfo(): boolean {
      return (
        this.hasAttachments ||
        this.hasCCs ||
        this.hasBounceInfo ||
        this.replyInfo.autoResponseSent
      )
    },
  },
  watch: {
    replyInfo: {
      immediate: true,
      handler(value) {
        this.editedIncomingReply = value.description
      },
    },
    rolledOverReply: {
      handler(value) {
        if (this.$screen.isTabletOrDesktop(this.$mq)) {
          this.showMoreOptions = value
        }
      },
    },
  },
  methods: {
    closeOptions() {
      this.showMoreOptions = true
      this.$nextTick(() => {
        this.showMoreOptions = false
      })
    },
    handleViewOriginalEmail() {
      this.closeOptions()
      this.$emit('original-message-requested', this.replyInfo)
    },
    initiateLinkedTask(id: Number) {
      // This vuex prop is being watched by the task/convo detail header
      this.$store.set('app/itemEventForLinkedTaskID', id)
    },
    enableIncomingReplyEdit() {
      this.isEditing = true
    },
    disableEditMode() {
      this.isEditing = false
    },
    async submit() {
      this.isSubmitting = true

      try {
        await this.submitHandler(this.replyInfo.id, this.editedIncomingReply)
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isSubmitting = false
        this.disableEditMode()
      }
    },
  },
})
